module.exports = {
  A: { api: 'A', human: 'Klasse A' },
  B: { api: 'B', human: 'Klasse B' },
  C: { api: 'C', human: 'Klasse C' },
  X: { api: 'X', human: 'Klasse X' }
}
